import React, { useCallback, useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Row, Col } from "antd";

import InfoLabel from "../../../app/generic/infoLabel";
import LoadSkeleton from "../../../app/generic/loadSkeleton";
import CheckboxItem from "../../../app/generic/checkboxItem";
import IncotermItem from "../../../app/generic/incotermItem";
import InputNumberItem from "../../../app/generic/inputNumberItem";
import { canBeCod } from "../../../../modules/consignmentFunctions";
import CashOnDeliveryItem from "../../../app/generic/cashOnDeliveryItem";
import ConsignmentPriceItem from "../../../app/generic/consignmentPriceItem";

const getColumnWidth = (values) => 24 / (values.filter((c) => c).length || 48);

const Services = ({
  rules,
  onAdrChange,
  pickupCountry,
  formItemLayout,
  deliveryCountry,
  selectedProduct,
  onSetHasServices,
  onAnyValueChange,
  onSetCarryToFloor,
  getFieldDecorator,
}) => {
  const intl = useIntl();

  const [enabledAdr, setEnabledAdr] = useState();
  const [enabledCod, setEnabledCod] = useState();
  const [specialServices, setSpecialServices] = useState();
  const [enabledIncoterms, setEnabledIncoterms] = useState();
  const [enabledInsurance, setEnabledInsurance] = useState();
  const [enabledEuroPallet, setEnabledEuroPallet] = useState();
  const [enabledTimeSlotBooking, setEnabledTimeSlotBooking] = useState();
  useEffect(() => {
    const b2c = selectedProduct && selectedProduct.code === "ECD_B2C";
    setSpecialServices(b2c);
    setEnabledAdr(rules && rules.adr);
    setEnabledEuroPallet(
      (b2c || (selectedProduct && selectedProduct.code === "ECD_B2B")) &&
        rules &&
        rules.euroPalletBack,
    );
    setEnabledIncoterms(
      selectedProduct &&
        selectedProduct.code !== "ECD_B2C" &&
        selectedProduct.code !== "ECD_B2B",
    );
    setEnabledTimeSlotBooking(
      selectedProduct &&
        (selectedProduct.code === "ERI" ||
          selectedProduct.code === "PPI" ||
          selectedProduct.code === "ECI" ||
          selectedProduct.code === "SPI" ||
          selectedProduct.code === "ECI_B2C"),
    );
    setTimeout(() => {
      setEnabledCod();
      setEnabledInsurance();
    }, 500);
    setTimeout(() => {
      setEnabledCod(
        rules &&
          rules.cashOnDelivery &&
          selectedProduct &&
          selectedProduct.code !== "ELD" &&
          selectedProduct.code !== "ELI" &&
          selectedProduct.code !== "ERI" &&
          selectedProduct.code !== "ERD" &&
          selectedProduct.code !== "PPI" &&
          canBeCod(deliveryCountry, pickupCountry) &&
          canBeCod(pickupCountry, deliveryCountry, true),
      );
      setEnabledInsurance(rules && rules.insurance);
    }, 1000);
  }, [rules, pickupCountry, deliveryCountry, selectedProduct]);

  const [cod, setCod] = useState(false);
  const handleCodChange = useCallback(
    (number) => {
      onAnyValueChange();
      setCod(number > 0 && false);
    },
    [onAnyValueChange],
  );

  const handleCarryToFloorChange = useCallback(
    (e) => {
      onAnyValueChange();
      onSetCarryToFloor(e.target.checked);
    },
    [onAnyValueChange, onSetCarryToFloor],
  );

  const [firstCol, setFirstCol] = useState(24);
  useEffect(() => {
    setFirstCol(
      getColumnWidth([enabledEuroPallet, enabledCod, enabledInsurance]),
    );
  }, [enabledCod, enabledInsurance, enabledEuroPallet]);

  const [thirdCol, setThirdCol] = useState(24);
  useEffect(() => {
    setThirdCol(getColumnWidth([enabledAdr, enabledIncoterms, cod]));
  }, [cod, enabledAdr, enabledIncoterms]);

  const [fourthCol, setFourthCol] = useState(24);
  useEffect(() => {
    setFourthCol(getColumnWidth([enabledTimeSlotBooking]));
  }, [enabledTimeSlotBooking]);

  useEffect(() => {
    onSetHasServices &&
      onSetHasServices(firstCol > 1 || thirdCol > 1 || specialServices);
  }, [firstCol, thirdCol, specialServices, onSetHasServices]);

  return rules ? (
    <>
      {firstCol > 1 && (
        <Row gutter={20}>
          {enabledEuroPallet && (
            <Col
              span={8}
              className="center"
              offset={firstCol === 8 ? 0 : firstCol === 12 ? 2 : 8}
            >
              <InputNumberItem
                max={20}
                label={intl.formatMessage({
                  id: "consignment.services.peurCount",
                  defaultMessage: "Počet P-EUR",
                })}
                fieldName="palletCount"
                formItemLayout={formItemLayout}
                onInputChange={onAnyValueChange}
                getFieldDecorator={getFieldDecorator}
              />
            </Col>
          )}
          {enabledCod && (
            <Col
              span={8}
              className="center"
              offset={
                firstCol === 8
                  ? 0
                  : firstCol === 12
                    ? enabledEuroPallet
                      ? 4
                      : 2
                    : 8
              }
            >
              <CashOnDeliveryItem
                optional
                skeleton
                product={selectedProduct}
                formItemLayout={formItemLayout}
                onAmountChange={handleCodChange}
                getFieldDecorator={getFieldDecorator}
                onCurrencyChange={onAnyValueChange}
                amountFieldName="cashOnDeliveryAmount"
                currencyFieldName="cashOnDeliveryCurrencyId"
                productCurrencies={rules.cashOnDeliveryCurrencies}
                currencies={deliveryCountry && deliveryCountry.currencies}
              />
            </Col>
          )}
          {enabledInsurance && (
            <Col
              span={8}
              className="center"
              offset={
                firstCol === 8
                  ? 0
                  : firstCol === 12
                    ? enabledEuroPallet || enabledCod
                      ? 4
                      : 2
                    : 8
              }
            >
              <ConsignmentPriceItem
                optional
                skeleton
                emptyCurrencies
                product={selectedProduct}
                amountFieldName="insurance"
                formItemLayout={formItemLayout}
                getFieldDecorator={getFieldDecorator}
                currencyFieldName="insuranceCurrencyId"
                onConsignmentPriceChange={onAnyValueChange}
                onConsignmentPriceCurrencyChange={onAnyValueChange}
                deliveryCountryCurrencies={
                  deliveryCountry && deliveryCountry.currencies
                }
                labelValue={
                  <InfoLabel
                    info={intl.formatMessage({
                      id: "calculator.insuranceInfo",
                      defaultMessage: "zadejte hodnotu zásilky",
                    })}
                    label={intl.formatMessage({
                      id: "consignment.insurance",
                      defaultMessage: "Připojištění",
                    })}
                  />
                }
              />
            </Col>
          )}
        </Row>
      )}
      {specialServices && (
        <Row gutter={20}>
          <Col span={12} className="center">
            <CheckboxItem
              label={intl.formatMessage({
                id: "consignment.services.carryToFloor",
                defaultMessage: "Výnos do patra",
              })}
              fieldName="carryToFloor"
              formItemLayout={formItemLayout}
              onChange={handleCarryToFloorChange}
              getFieldDecorator={getFieldDecorator}
              className="calculation-form-center"
            />
          </Col>
          <Col span={12} className="center">
            <CheckboxItem
              label={intl.formatMessage({
                id: "consignment.services.transportOldAppliance",
                defaultMessage: "Odvoz starého spotřebiče",
              })}
              fieldName="transportOldAppliance"
              onChange={onAnyValueChange}
              formItemLayout={formItemLayout}
              getFieldDecorator={getFieldDecorator}
              className="calculation-form-center"
            />
          </Col>
        </Row>
      )}
      {thirdCol > 1 && (
        <Row gutter={20}>
          {enabledAdr && (
            <Col span={thirdCol} className="center">
              <CheckboxItem
                fieldName="adr"
                onChange={onAdrChange}
                label="&nbsp;&nbsp;ADR"
                formItemLayout={formItemLayout}
                getFieldDecorator={getFieldDecorator}
              />
            </Col>
          )}
          {cod && (
            <Col span={thirdCol} className="center">
              <CheckboxItem
                label={intl.formatMessage({
                  id: "consignment.services.payByCreditCard",
                  defaultMessage: "Platba dobírky platební kartou",
                })}
                fieldName="payByCreditCard"
                onChange={onAnyValueChange}
                formItemLayout={formItemLayout}
                getFieldDecorator={getFieldDecorator}
                className="calculation-form-center"
              />
            </Col>
          )}
          {enabledIncoterms && (
            <Col span={thirdCol} className="center">
              <Row type="flex" justify="center">
                <Col span={thirdCol === 24 ? 6 : 12}>
                  <IncotermItem
                    optional
                    inlineLabel
                    onChange={onAnyValueChange}
                    label={intl.formatMessage({
                      id: "consignment.services.incoterms",
                      defaultMessage: "Parita",
                    })}
                    formItemLayout={formItemLayout}
                    productCode={selectedProduct.code}
                    className="calculation-form-center"
                    getFieldDecorator={getFieldDecorator}
                  />
                </Col>
              </Row>
            </Col>
          )}
        </Row>
      )}
      {fourthCol > 1 && (
        <Row gutter={20}>
          {enabledTimeSlotBooking && (
            <Col span={fourthCol} className="center">
              <CheckboxItem
                fieldName="timeSlotBooking"
                onChange={onAnyValueChange}
                formItemLayout={formItemLayout}
                getFieldDecorator={getFieldDecorator}
                label={intl.formatMessage({
                  id: "consignment.services.timeSlotBooking",
                  defaultMessage: "Time-slot booking",
                })}
              />
            </Col>
          )}
        </Row>
      )}
    </>
  ) : (
    <LoadSkeleton />
  );
};

export default Services;
